// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".selected[data-v-fa885196]{color:var(--text-text-default);background-color:var(--highlight-primary)}", ""]);
// Exports
module.exports = exports;
